import Cookies from "js-cookie";

const AccessTokenKey = "PHPSESSID";
//拿到token
const RefreshTokenKey = "refreshToken";
//刷新token
export function setAccessToken(token) {
  Cookies.set(AccessTokenKey, token);
}

export function setRefreshToken(token) {
  Cookies.set(RefreshTokenKey, token);
}

export function getAccessToken() {
  const cookie = Cookies.get(AccessTokenKey);
  return cookie;
}

export function getRefreshToken() {
  return Cookies.get(RefreshTokenKey);
}

export function removeAccessToken() {
  Cookies.remove(AccessTokenKey);
}

export function removeRefreshToken() {
  Cookies.remove(RefreshTokenKey);
}
